<script lang="ts" setup>
import { computed, defineComponent, type Ref, ref, onMounted } from "vue";
import algoliasearch from "algoliasearch";
import code from "./code";
import StoryBox from "./StoryBox.vue";

const found: Ref<any> = ref([]);
const query = ref("");
const numPages = ref(0);
const message = ref("");
const pageSize = ref(15);
const currentPage = ref(0);
const resultCount = ref(0);

const client = algoliasearch(
  [...code.code].reverse().join(""),
  [...code.app].reverse().join("")
);
const index = client.initIndex("wildermuth.com");

const more = computed(() => numPages.value > currentPage.value + 1);

onMounted(async () => {
  const decoded = decodeURIComponent(window.location.search);
  const searchString = decoded.substring(3);
  if (searchString) {
    query.value = searchString;
    await performSearch();
  }
});

async function searchMore() {
  if (query.value) {
    currentPage.value++;
    await performSearch();
  }
}

async function search() {
  if (query.value) {
    window.location.replace(`/search/index.html?q=${encodeURIComponent(query.value)}`)
  }
}

async function performSearch() {
  try {
    message.value = `Searching...`;
    found.value = [];
    const result = await index.search(query.value, {
      hitsPerPage: pageSize.value,
      page: currentPage.value,
    });

    if (result && result.hits && result.hits.length > 0) {
      found.value = result.hits.sort((a: any, b: any) =>
        new Date(a.date) < new Date(b.date) ? 1 : -1
      ) as any[];
      numPages.value = result.nbPages;
      resultCount.value = result.nbHits;
    }
  } catch (e) {
    message.value = "Error Occurred while Searching";
    numPages.value = 0;
  } finally {
    message.value = "";
  }
}
</script>

<template>
  <div class="flex flex-col">
    <div class="flex justify-end">
      <a href="https://www.algolia.com/"
         target="_blank"
         class="w-40 my-2"><img :src="'/img/algolia.svg'"
             alt="Search by Algolia" /></a>
    </div>
    <div class="flex mb-4  gap-2 items-center">
      <input class="flex-grow
        form-input w-full py-2 px-3 border border-inherit dark:border-gray-600 dark:bg-slate-900 dark:text-slate-200 rounded h-10 outline-none bg-transparent focus:border-amber-500/50 dark:focus:border-amber-500/50 focus:shadow-none focus:ring-0 text-[15px]"
             ref="searchInput"
             type="text"
             v-model="query"
             @keyup.enter="search()"
             placeholder="Search here..."
             autofocus />
      <div class="my-1">
        <button class="btn bg-amber-500 hover:bg-amber-600 border-amber-500 hover:border-amber-600 text-white rounded-md h-10 justify-center flex items-center"
                @click="search()">Search</button>
      </div>
    </div>
    <div v-if="message">{{ message }}</div>
    <div class="flex flex-col"
         v-if="found">
      <div class="text-sm text-gray-100"
           v-if="resultCount > 0">
        #/Results: {{ resultCount }} - Page {{ currentPage + 1 }} of
        {{ numPages }}
      </div>
      <div class="grid grid-cols-1 md:grid-cols-2 my-4 xl:grid-cols-3 gap-8">
        <div v-for="item in found"
             :key="item.objectID">
          <StoryBox :story="item" />
        </div>
      </div>
    </div>
    <div class="my-4">
      <button @click="searchMore()"
              class="btn btn-success text-sm"
              v-if="more">
        Get more results...
      </button>
    </div>
  </div>
</template>
